import { ReactComponent } from "./delete-fill.svg";

interface Props {
  width?: number;
  height?: number;
}

const DeleteFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default DeleteFillIcon;
